<template>
  <div>
    <div class="ly-title">
      <h2 class="title">FAQ{{ $t("messages.manage") }}</h2>
      <idc-breadcrumb :breadcrumbList="breadcrumbList" />
    </div>
    <div class="ly-content">
      <el-row>
        <div class="ly-post">
          <div class="ly-inner">
            <div class="post post-detail">
              <div class="post-detail-header">
                <div class="ly-title">
                  <h2 class="title">
                    <span class="title-con">{{ title }}</span>
                  </h2>
                </div>
                <div class="ly-desc">
                  <ul class="desc">
                    <li
                      class="desc-item"
                      v-for="(item, index) in descData"
                      :key="index"
                    >
                      <div class="desc-tit">{{ item.title }}</div>
                      <div class="desc-con">{{ item.content }}</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="post-detail-container con-editor">
                <div class="ly-download">
                  <div
                    class="download"
                    v-show="filePhysName !== null && filePhysName !== ''"
                  >
                    <el-button
                      plain
                      round
                      size="medium"
                      @click="fileDownLoad"
                      >{{ $t("messages.attachedFile") }}</el-button
                    >
                    <div class="download-file">
                      <i class="icon-Paperclip" />
                      {{ filePhysName }}
                    </div>
                  </div>
                </div>
                <div class="contents ProseMirror" v-html="ctntText"></div>
              </div>
            </div>
          </div>
          <div class="ly-detail-footer" v-show="sameUser == 'Y'">
            <!-- 22.03.17 수정, 삭제 버튼 추가 -->
            <el-button plain size="small" type="save" @click="setEditingBBS">{{
              $t("messages.btnEdit")
            }}</el-button>
            <el-button size="small" type="save" @click="deleteBBS">{{
              $t("messages.btnDelete")
            }}</el-button>
            <!-- 22.03.17 수정, 삭제 버튼 추가 -->
          </div>
        </div>
      </el-row>
      <el-row>
        <button
          class="btn-nav"
          v-for="(item, index) in navData"
          :key="index"
          @click="setNewBBSData(item)"
        >
          <i
            class="icon"
            :class="`${
              item.type == 'prev' ? 'icon-CaretUp' : 'icon-CaretDown'
            }`"
          />
          <span class="type" v-if="item.type == 'prev'">{{
            $t("messages.btnPrev")
          }}</span>
          <span class="type" v-else>{{ $t("messages.btnNext") }}</span>
          <span class="title">
            {{ item.title }}
          </span>
        </button>
      </el-row>
    </div>
    <div class="ly-footer">
      <el-button plain type="info" @click="goList">{{
        $t("messages.btnList")
      }}</el-button>
    </div>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    >
    </loading>
  </div>
</template>

<script>
import axios from "axios";
import FileSaver from "file-saver";
import { getDateTime, getYMD, commonFileDownload } from "@/assets/js/common.js";
import IdcBreadcrumb from "@/components/common/IdcBreadcrumb";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    IdcBreadcrumb,
    Loading
  },
  data() {
    return {
      descData: [
        { title: "등록자", content: "" },
        { title: "등록일", content: "" },
      ],
      navData: [],
      bbsType: "",
      bbsSeq: "",
      apiUrl: "",
      titleHead: "",
      title: "",
      ctntText: "",
      atcFileId: "",
      filePhysName: "",
      fileLgicName: "",
      filePath: "",
      sameUser: "",
      isLoading: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.bbsType = this.$route.params.bbsType;
      this.bbsSeq = this.$route.params.bbsSeq;
      this.apiUrl = this.$route.params.apiUrl;

      this.getDetailBBSData();
      this.getPrevNextBBSData();
    });
  },
  computed: {
    breadcrumbList() {
      return this.$route.meta.navigator;
    },
  },
  methods: {
    goList: function () {
      this.$router.push({ name: "Faq" });
    },

    getDetailBBSData: function () {
      this.isLoading = true;
      const reqData = {};
      reqData["bbsType"] = this.bbsType;
      reqData["bbsSeq"] = this.bbsSeq;

      this.$BIZ_SERVICE
        .post(this.apiUrl.getDetailBBSData, reqData)
        .then((res) => {
          console.log(res);
          if (res.data.resData !== null) {
            this.title = res.data.resData.title;
            this.descData[0].content = res.data.resData.userNmDept;
            this.descData[1].content = res.data.resData.regDt;

            this.sameUser = res.data.resData.sameUser;

            let ctntTxt = "";
            let tmpTxt = "";
            tmpTxt = res.data.resData.sbstClob;
            if (tmpTxt != null) {
              ctntTxt = tmpTxt
                // .replaceAll("&lt;", "<")
                // .replaceAll("&gt;", ">")
                // .replaceAll("<p></p>", "<br/>");
            }
            this.ctntText = tmpTxt;

            this.atcFileId = res.data.resData.atcFileId;
            this.filePhysName = res.data.resData.filePhysName;
            this.fileLgicName = res.data.resData.fileLgicName;
            this.filePath = res.data.resData.filePath;
          }
        })
        .catch((error) => {
          alert(error);
        })
        .finally(() => {this.isLoading = false;});
    },

    getPrevNextBBSData: function () {
      const reqData = {};
      reqData["bbsType"] = this.bbsType;
      reqData["bbsSeq"] = this.bbsSeq;

      this.$BIZ_SERVICE
        .post(this.apiUrl.getPrevNextBBSData, reqData)
        .then((res) => {
          console.log(res);
          if (res.data.resData !== null) {
            let prev_obj = {};
            let next_obj = {};

            let tmp_ary = new Array();

            prev_obj.type = "prev";
            prev_obj.bbsSeq = res.data.resData.prevBbsSeq;
            prev_obj.title = res.data.resData.prevTitle;
            tmp_ary.push(prev_obj);

            next_obj.type = "next";
            next_obj.bbsSeq = res.data.resData.nextBbsSeq;
            next_obj.title = res.data.resData.nextTitle;
            tmp_ary.push(next_obj);

            this.navData = tmp_ary;
          } else {
            this.navData = [];
          }
        })
        .catch((error) => {
          alert(error);
        })
        .finally(() => {});
    },

    setNewBBSData: function (item) {
      if (item.bbsSeq != null) {
        this.bbsSeq = item.bbsSeq;

        this.getDetailBBSData();
        this.getPrevNextBBSData();
      }
    },

    fileDownLoad: function () {
      if (this.atcFileId != "") {
        const params = {};
        params.atcFile = this.atcFileId;
        params.filePhysName = this.filePhysName;
        params.fileLgicName = this.fileLgicName;
        params.filePath = this.filePath;

        commonFileDownload(
          this.$BIZ_SERVICE,
          FileSaver,
          params,
          this.$API_URLS.OssCmntyApi.fileDownload
        );
      } else {
        alert("다운로드 할 파일 정보가 없습니다.");
      }
    },

    deleteBBS: function () {
      let tmpData = {};
      tmpData["bbsType"] = "FAQ";
      tmpData["bbsSeq"] = this.bbsSeq;

      let tmpAry = new Array();
      tmpAry.push(tmpData);

      const reqData = {};
      reqData["chkList"] = tmpAry;

      this.$BIZ_SERVICE
        .post(this.$API_URLS.OssCmntyApi.deleteBBS, reqData)
        .then((res) => {
          console.log(res);
          if (res.data.resData > 0) {
            alert("삭제 되었습니다.");
            this.goList();
          }
        })
        .catch((error) => {
          if (this.isLoading == true) {
            alert(error);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setEditingBBS: function () {
      let fileList = new Array();
      if (this.filePhysName != null && this.filePhysName != "") {
        // 수정창에서 보일 수 있도록 가짜로 파일을 만들어서 fileList에 인가함.
        fileList[0] = new File([], this.filePhysName, {
          type: "text/plain",
          lastModified: new Date(),
        });
      }
      this.$router.push({
        name: "FaqRegist",
        params: {
          mode: "update",
          bbsType: "FAQ",
          bbsSeq: this.bbsSeq,
          editorContent: this.ctntText,
          fileList: fileList,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ly {
  &-content {
    padding: 15px 0 20px;
    border-top: 1px solid $--color-light-gray;
  }
}
.el-row {
  margin-bottom: 15px;
}

::v-deep {
  .con-editor .ProseMirror table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;
  }
  .con-editor .ProseMirror table th {
    font-weight: bold;
    text-align: left;
    background-color: #f1f3f5;
  }
  .con-editor .ProseMirror table td,
  .con-editor .ProseMirror table th {
    min-width: 1em;
    border: 2px solid #ced4da;
    padding: 3px 5px;
    vertical-align: top;
    box-sizing: border-box;
    position: relative;
  }
}
</style>
